export default {
    methods: {
        showErrorModal(title, message) {
            const text = typeof message === 'string' ? message : String(message || 'Something went wrong. Please try again.');
            return this.$bvModal.msgBoxOk(text, {
                title: title || 'Error',
                size: 'sm',
                centered: true,
                okVariant: 'primary',
                okTitle: 'OK',
                headerBgVariant: 'danger',
                headerTextVariant: 'light',
                bodyClass: 'error-modal-body',
            });
        },
    },
};
